import cn from 'clsx';
import React from 'react';

import DownloadIcon from '@/public/images/downloadFileIcon.svg';
import FileIcon from '@/public/images/FileIcon.svg';
import LinkIcon from '@/public/images/LinkIcon.svg';
import getRootServerUrl from '@/src/app/utils/getRootServerUrl';
import prepareOutsideLink from '@/src/app/utils/prepareOutsideLink';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {ATTACHMENT_TYPES} from '@/src/watchCourse/containers/WatchCourse';

import {Text} from '../../index';
import css from '../styles/AttachmentsLists.module.css';

interface FileProps {
  id: number;
  pdf_file: string;
  title: string;
}

interface LinkProps {
  id: number;
  title: string;
  link_url: string;
}

interface AttachmentsListsProps {
  files: FileProps[];
  links: LinkProps[];
  onAttachmentClick?: (id: number, type: string) => void;
  isSquare?: boolean;
  isWhiteBackground?: boolean;
  isDisableLinks?: boolean;
}

const AttachmentsLists = ({
  files,
  links,
  onAttachmentClick,
  isSquare,
  isWhiteBackground,
  isDisableLinks,
}: AttachmentsListsProps) => {
  if (!files.length && !links.length) {
    return null;
  }

  const Tag = isDisableLinks ? 'span' : 'a';

  return (
    <div
      className={cn(css.attachments, {
        [css.attachmentsSquare]: isSquare,
        [css.whiteBackground]: isWhiteBackground,
      })}
    >
      {Boolean(files.length) && (
        <>
          <Text
            fontSize={Text.FONT_SIZE.SIZE_14}
            fontFamily={Text.FONT_FAMILY.POPPINS}
            fontWeight={Text.FONT_WEIGHT.BOLD}
            className={css.attachmentsTitle}
          >
            <TextLocal id={'create-course.attachments'} />
          </Text>
          <ul className={css.contentList}>
            {files.map((files) => {
              return (
                <li
                  key={files.pdf_file}
                  className={css.fileLink}
                  onClick={() =>
                    onAttachmentClick &&
                    onAttachmentClick(files.id, ATTACHMENT_TYPES.file)
                  }
                >
                  <Tag
                    target="_blank"
                    href={`${getRootServerUrl()}/${files.pdf_file}`}
                    rel="noreferrer"
                    className={css.linkAttachment}
                  >
                    <span className={css.iconWrapper}>
                      <FileIcon />
                    </span>
                    <span className={css.fileName}>{files.title}</span>
                    <span>{!isDisableLinks && <DownloadIcon />}</span>
                  </Tag>
                </li>
              );
            })}
          </ul>
        </>
      )}
      {Boolean(links.length) && (
        <>
          <Text
            fontSize={Text.FONT_SIZE.SIZE_14}
            fontFamily={Text.FONT_FAMILY.POPPINS}
            fontWeight={Text.FONT_WEIGHT.BOLD}
            className={css.attachmentsTitle}
          >
            <TextLocal id={'create-course.links'} />
          </Text>
          <ul className={css.contentList}>
            {links.map((link) => {
              return (
                <li
                  key={link.link_url}
                  onClick={() =>
                    onAttachmentClick &&
                    onAttachmentClick(link.id, ATTACHMENT_TYPES.link)
                  }
                >
                  <Tag
                    target="_blank"
                    href={prepareOutsideLink(link.link_url)}
                    rel="noreferrer"
                    className={css.linkAttachment}
                  >
                    <span className={css.iconWrapper}>
                      <LinkIcon />
                    </span>
                    <span className={css.linkName} title={link.title}>
                      {link.title}
                    </span>
                  </Tag>
                </li>
              );
            })}
          </ul>
        </>
      )}
    </div>
  );
};

export default AttachmentsLists;
